var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_\\uAE30\\uC5C5\\uD68C\\uC6D0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_71",
    "data-name": "\\uC0AC\\uAC01\\uD615 71",
    width: 50,
    height: 50,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_120",
    "data-name": "\\uADF8\\uB8F9 120",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_179",
    "data-name": "\\uD328\\uC2A4 179",
    d: "M27.181,48.858H6.829A.829.829,0,0,1,6,48.029V14.784a.829.829,0,0,1,.418-.72L28.859,1.252a.829.829,0,0,1,1.24.72V17.181a.829.829,0,1,1-1.658,0V3.4L7.658,15.265V47.2H27.181a.829.829,0,1,1,0,1.658",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_180",
    "data-name": "\\uD328\\uC2A4 180",
    d: "M22.133,48.858h-7V39.927h7ZM16.793,47.2h3.681V41.585H16.793Z",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_62",
    "data-name": "\\uC0AC\\uAC01\\uD615 62",
    width: 1.658,
    height: 2.618,
    transform: "translate(12.142 19.016)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_63",
    "data-name": "\\uC0AC\\uAC01\\uD615 63",
    width: 1.658,
    height: 2.618,
    transform: "translate(12.142 25.605)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_64",
    "data-name": "\\uC0AC\\uAC01\\uD615 64",
    width: 1.658,
    height: 2.619,
    transform: "translate(12.142 32.193)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_65",
    "data-name": "\\uC0AC\\uAC01\\uD615 65",
    width: 1.658,
    height: 2.618,
    transform: "translate(17.807 19.016)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_66",
    "data-name": "\\uC0AC\\uAC01\\uD615 66",
    width: 1.658,
    height: 2.618,
    transform: "translate(17.807 25.605)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_67",
    "data-name": "\\uC0AC\\uAC01\\uD615 67",
    width: 1.658,
    height: 2.619,
    transform: "translate(17.807 32.193)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_68",
    "data-name": "\\uC0AC\\uAC01\\uD615 68",
    width: 1.658,
    height: 2.618,
    transform: "translate(23.471 19.016)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_69",
    "data-name": "\\uC0AC\\uAC01\\uD615 69",
    width: 1.658,
    height: 2.618,
    transform: "translate(23.471 25.605)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_70",
    "data-name": "\\uC0AC\\uAC01\\uD615 70",
    width: 1.658,
    height: 2.619,
    transform: "translate(23.471 32.193)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_181",
    "data-name": "\\uD328\\uC2A4 181",
    d: "M40.813,17.181v-4.6H32.454v4.6H29.27V48.628H44V17.181Zm-5.665,23.01H33.759v-2.62h1.389Zm0-5.965H33.759V31.608h1.389Zm0-6.588H33.759V25.019h1.389Zm4.361,12.553H38.121v-2.62h1.388Zm0-5.965H38.121V31.608h1.388Zm0-6.588H38.121V25.019h1.388Z",
    fill: "#d8d8d8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon_기업회원.f2d6c75fd3ddace5d417a071956c7fc8.svg";
export { ForwardRef as ReactComponent };